import { JwtPayload, jwtDecode } from "jwt-decode";
import { useApplicationStore } from "../stores";

export const isTokenExpired = (token: string) => {
  try {
    const { exp } = jwtDecode<JwtPayload>(token);

    if (!exp) return true;

    return Date.now() >= exp * 1000;
  } catch {
    return true;
  }
};

export const handleTokenExpiration = () => {
  useApplicationStore.getState().setApplicationProps({ tokenExpired: true });
  localStorage.clear();
};
